import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { message } from "antd";

class RAGReportStore {
  ragReportData = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      ragReportData: observable,
      total: observable,
      loading: observable,

      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    vehicleId,
    filterBy,
    offset,
    limit,
    returnType,
    reportType,
    pageNo,
    fromDate,
    toDate,
  }) {
    this.loading = true;
    if (reportType == 1) {
      var postData = {
        companyId: companyId,
        driverId: driverId,
        vehicleId: vehicleId,
        filterBy: filterBy,
        // fromDate: fromDate,
        // toDate: toDate,

        fromMonth: fromDate,
        toMonth: toDate,
        reportType: reportType,
        offset: offset,
        limit: limit,
        page: pageNo,
      };
    }
    if (reportType == 3 || reportType == 2) {
      var postData = {
        companyId: companyId,
        driverId: driverId,
        vehicleId: vehicleId,
        filterBy: filterBy,
        // fromDate: fromDate,
        // toDate: toDate,

        fromDate: fromDate,
        toDate: toDate,
        reportType: reportType,
        offset: offset,
        limit: limit,
        page: pageNo,
      };
    }
    var response
    if (config.pythonReport == 1) {
      response = await postApi.getClient('report').post("/driver_report/ragReport", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post("index.php?c=driver&a=getRagReportList", "postData=" + base64Input);
    }
    this.ragReportData = response?.data?.data?.ragReport;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/driver_report/ragReport/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        message.error("Failed to download the report. Please try again.")
      }
    } else {


      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportRagReportExcel&cid=" +
        getData.companyId +
        "&did=" +
        getData.Driver +
        "&rt=" +
        getData.reportType +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/driver_report/ragReport/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportMessage = false;
        message.error("Failed to download the report. Please try again.")
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportRagReportPdf&cid=" +
        getData.companyId +
        "&did=" +
        getData.Driver +
        "&rt=" +
        getData.reportType +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
}

export default RAGReportStore;
